export const SEASONS: Record<string, { label: string; months: number[] }> = {
  summer: { label: "Summer (Dec–Feb)", months: [11, 0, 1] },
  autumn: { label: "Autumn (Mar–May)", months: [2, 3, 4] },
  winter: { label: "Winter (Jun–Aug)", months: [5, 6, 7] },
  spring: { label: "Spring (Sep–Nov)", months: [8, 9, 10] },
};

export const currentSeason = (d = new Date()) => Object.keys(SEASONS).find((s) => SEASONS[s].months.includes(d.getMonth())) as string;

const pad = (n: number) => String(n).padStart(2, "0");
const localStamp = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

/** null = not scheduled; true/false = inside/outside its date window (yearly windows ignore the year and may wrap past New Year). */
export function inWindow(s: any, now = new Date()): boolean | null {
  if (!s.start && !s.end) return null;
  const t = localStamp(now);
  if (!s.yearly) return (!s.start || t >= s.start) && (!s.end || t <= s.end);
  const cur = t.slice(5), a = s.start ? s.start.slice(5) : "01-01T00:00", b = s.end ? s.end.slice(5) : "12-31T23:59";
  return a <= b ? cur >= a && cur <= b : cur >= a || cur <= b;
}

export function slideStatus(s: any, now = new Date()) {
  if (s.enabled === false || !s.image) return { label: "Off", tone: "neutral" };
  const w = inWindow(s, now);
  if (w === true) return { label: "Live now (scheduled)", tone: "green" };
  if (w === false) return { label: "Waiting for its dates", tone: "amber" };
  return { label: s.season ? `In rotation · ${SEASONS[s.season]?.label.split(" ")[0]}` : "In rotation", tone: "green" };
}

const any = (xs: any[]) => xs[Math.floor(Math.random() * xs.length)];
const shuffle = (xs: any[]) => xs.map((x) => [Math.random(), x] as [number, any]).sort((a, b) => a[0] - b[0]).map(([, x]) => x);
const withText = (b: any, s: any) => (s.heading ? s : { ...b, image: s.image, name: s.name });

/** Slides eligible right now, in random order: live scheduled ones take over, otherwise the unscheduled pool (season-filtered in season mode). */
export function heroPool(b: any, now = new Date(), force: number | null = null): any[] {
  const forced = force != null ? b.slides?.[force] : null;
  if (forced?.image) return [withText(b, forced)];
  const season = currentSeason(now);
  const pool = (b.slides || []).filter((s: any) => s.image && s.enabled !== false && inWindow(s, now) !== false
    && (b.rotation !== "season" || !s.season || s.season === season));
  return pool.length ? shuffle(pool).map((s) => withText(b, s)) : [b];
}

export function pickSlide(b: any, now = new Date(), force: number | null = null) {
  return any(heroPool(b, now, force));
}

/** Holidays switched on and inside their dates; the one that started last comes first. */
export const liveHolidays = (list: any[] = [], now = new Date()) =>
  list.filter((h) => h.enabled !== false && inWindow(h, now) === true).sort((a, b) => ((b.yearly ? b.start?.slice(5) : b.start) || "").localeCompare((a.yearly ? a.start?.slice(5) : a.start) || ""));

/** "12 days left to order…" for a holiday with a cut-off still ahead; "" once it has passed. Yearly cut-offs ignore the year. */
export function countdownText(h: any, now = new Date()): string {
  if (!h?.cutoff || !h.countdown_text) return "";
  const target = new Date(h.yearly ? `${now.getFullYear()}${h.cutoff.slice(4)}` : h.cutoff);
  const ms = target.getTime() - now.getTime();
  if (isNaN(ms) || ms < 0) return "";
  const days = Math.floor(ms / 86400000);
  return h.countdown_text.replace("{days}", days >= 1 ? `${days} day${days === 1 ? "" : "s"}` : "Just hours");
}
